// Constants for the Table Design Tab
export const BORDERS_SHADING_GROUP_ID = '_borders_shading_group';
export const SHADING_GROUP_ID = '_shading_group';
// Constants for Borders & Shading items
export const BORDERS_DROPDOWN_ID = '_borders_dropdown';
export const BORDER_COLOR_PICKER_ID = '_border_color_picker';
export const BORDER_WIDTH_DROPDOWN_ID = '_border_width_dropdown';
export const SHADING_COLOR_PICKER_ID = '_shading_color_picker';
